// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1UFFi","bigColWidth":"Table_bigColWidth__3Yn2X","biggerColWidth":"Table_biggerColWidth__1-QSR","row":"Table_row__21qpN","col":"Table_col__fgxuK"};